/**
 * Onglets du détail d'un job (6 comme le legacy, plus « Backfills » depuis l'orchestration du
 * 2026-10-10, et « Aperçu » pour un job low-code depuis le lot L07). L'onglet actif vit dans l'URL (`?tab=`).
 */
export const JOB_TABS = [
  'summary',
  'definition',
  'runs',
  'backfills',
  'costs',
  'notifications',
  'permissions',
  'preview',
] as const;
export type JobTab = (typeof JOB_TABS)[number];

export const isJobTab = (value: unknown): value is JobTab =>
  typeof value === 'string' && (JOB_TABS as readonly string[]).includes(value);
